import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';


export const initialValues = { isModalOpen: false, open: modalProps => { return null; }, close: () => { }, modalProps: {} };
export const CabinCrewModalContext = createContext(initialValues);

export const CabinCrewModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalProps, setModalProps] = useState({});

  const open = modalProps => {
    setIsModalOpen(true);
    setModalProps(modalProps);
  };

  const close = () => {
    setIsModalOpen(false);
    setModalProps({});
  };

  return (
    <CabinCrewModalContext.Provider value={{ isModalOpen, open, close, modalProps }}>
      {children}
    </CabinCrewModalContext.Provider>
  );
};
CabinCrewModalProvider.propTypes = {
  children: PropTypes.any
};
export const useCabinCrewModal = () => useContext(CabinCrewModalContext);
